<template>
  <div>
    <form @submit.prevent="submitForm">
      <DynamicForm
        :schema="schema"
        v-model="form"
        @status="saveStatus"
        ref="dynamicForm"
      />
    </form>
  </div>
</template>
<script>
import store from "../store.js";
import DynamicForm from "./DynamicForm";

export default {
  name: "StepOfertaDemanda",
  components: { DynamicForm },
  props: {
    // step: Number,
    clickedNext: Boolean,
    currentStep: {},
  },
  data() {
    return {
      store,
      schema: {},
      form: {},
      status: null,
      miV: {},
    };
  },
  async mounted() {
    // Cargando los colores personalizados del stepper form
    // Estilo del borde de la caja
    let boxes = document.getElementsByClassName("stepper-box");
    for (let i = 0; i < boxes.length; i++) {
      boxes[i].setAttribute(
        "style",
        "background-color: transparent; box-shadow: none"
      );
    }
    // Estilo del botón siguiente
    let botones = document.getElementsByClassName("stepper-button next");
    for (let i = 0; i < botones.length; i++) {
      botones[i].setAttribute(
        "style",
        "background-color:var(--iq-primary);  color: #ffffff;border-color: var(--iq-primary);padding: 8px 20px;font-size: 15px;font-weight: 500;line-height: 1.2;position: relative;border-radius: 25px;"
      );
    }
    // Estilo de los iconos de steps
    let iconos = document.querySelectorAll(".circle i");
    for (let i = 0; i < iconos.length; i++) {
      iconos[i].setAttribute("style", "background-color:var(--iq-primary);");
    }

    if (this.$store.state.step >= 0) {
      await this.loadFields(this.$i18n.locale, 99);
    } else {
      await this.loadFields(this.$i18n.locale, 0);
    }
    this.miV = this.$refs.dynamicForm.$v;
  },
  watch: {
    // para que cargue los campos con el lang correcto
    "$i18n.locale": function () {
      // Para actualizar el locale en el store (para fechas)
      //this.$store.state.interfaseLang = this.$i18n.locale
      // console.log(this.$i18n.locale)
      this.loadFields(this.$i18n.locale, 3);
    },
    miV: {
      handler: function (val) {
        if (!val.$invalid) {
          //Aquí tiene que mandar cada campo del form para que se agregue al objeto form del parent
          this.$emit("can-continue", { value: true });

          var extendedForm = [];
          for (const [key, value] of Object.entries(this.schema)) {
            var extendedField = {};
            Object.defineProperty(extendedField, "fid", {
              enumerable: true,
              configurable: true,
              writable: true,
              value: value.idField,
            });
            Object.defineProperty(extendedField, "fname", {
              enumerable: true,
              configurable: true,
              writable: true,
              value: key,
            });
            Object.defineProperty(extendedField, "fvalue", {
              enumerable: true,
              configurable: true,
              writable: true,
              value: this.form[key],
            });
            extendedForm.push(extendedField);
          }
          store.commit("appendToRegForm", extendedForm);
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.miV.form.$touch();
      }
    },
  },
  // methods: {
  //     async loadFields(lang){
  //     var that = this;
  //     const axios = require("axios") // eslint-disable-line
  //     var url = this.$websiteFront + "/api/json-reg-oferta-demanda-fields.php";
  //     axios
  //         .post(url, {
  //         dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
  //         appid: 1,
  //         lang: lang,
  //         ide: that.$route.params.ide,
  //         pli: that.$route.params.pli,
  //         gid: that.store.state.usr.gid,
  //         objR: that.$store.state.evento.objetivo_ronda
  //         })
  //         .then(function (response) {
  //         // if (response.data) {
  //         //     that.schema=response.data
  //         //     //return response.data
  //         // } else {
  //         //     console.log('Error en carga de campos')
  //         // }
  //         if (response.data) {
  //                 that.schema=response.data.fields
  //             if (response.data.valoresdef) {
  //                     that.form=response.data.valoresdef
  //                 }
  //             } else {
  //                 console.log('Error en carga de campos')
  //             }
  //         })
  //         .catch(function (error) {
  //         console.log(error)
  //         })
  //     },

  //     saveStatus (status) {
  //     this.status = status
  //     }
  // },
  methods: {
    async loadFields(lang) {
      const axios = require("axios"); // eslint-disable-line
      const url =
        this.$websiteFront + "/api/json-reg-oferta-demanda-fields.php";
      const maxIntentos = 3;
      const delayMs = 400;

      for (let intento = 1; intento <= maxIntentos; intento++) {
        try {
          const response = await axios.post(url, {
            dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
            appid: 1,
            lang: lang,
            ide: this.$route.params.ide,
            pli: this.$route.params.pli,
            gid: this.store.state.usr.gid,
            objR: this.$store.state.evento.objetivo_ronda,
          });

          if (response.data) {
            this.schema = response.data.fields;
            if (response.data.valoresdef) {
              this.form = response.data.valoresdef;
            }
            return; // Si la petición es exitosa, salimos de la función
          } else {
            console.log("Error en carga de campos");
          }
        } catch (error) {
          console.log(`Intento ${intento} fallido:`, error.message);

          // Si el error es ERR_HTTP2_PROTOCOL_ERROR, reintentar hasta 3 veces
          if (
            error.message.includes("ERR_HTTP2_PROTOCOL_ERROR") &&
            intento < maxIntentos
          ) {
            await new Promise((resolve) => setTimeout(resolve, delayMs)); // Espera 400ms antes de reintentar
          } else {
            console.error("Error en la carga de campos, no se pudo recuperar.");
            break; // Si no es el error esperado o ya se intentó 3 veces, salir del loop
          }
        }
      }
    },

    saveStatus(status) {
      this.status = status;
    },
  },
};
</script>
